import { put, call, all, takeLatest } from 'redux-saga/effects';
import axiosConfig from '../../services/axiosConfig';
import { fetchDsrLogsDownTimeFailure, fetchDsrLogsDownTimeSuccess } from './action';
import { FETCH_DSR_LOGS_DOWNTIME } from './types';
import get from 'lodash/get';
import { notification } from 'antd';

/** Get all DSR logs Down Time */
function* fetchDsrLogsDownTime(payload) {
  const userEmail = JSON.parse(localStorage.getItem('user')).email;

  try {
    if (payload.selectedProject == undefined) {
      yield put(fetchDsrLogsDownTimeSuccess([]));
    } else {
      const res = yield axiosConfig.get(
        `/dsr-log-downtimes?projectId=${payload.selectedData.projectId}&logDate=${payload.selectedData.logDate}&userEmail=${userEmail}&sowId=${payload.sowId}&readOnly=true`
      );
      const response = get(res, ['data', 'data'], {});
      if (res.status === 200) {
        // if (response.length == 0) {
        //     notification.error({
        //         message: 'No records found for this data range.',
        //     });
        // }
        yield put(fetchDsrLogsDownTimeSuccess({ response }));
      } else {
        notification.error({
          message: 'Something went wrong. Please try again.',
        });
      }
    }
  } catch (error) {
    yield put(fetchDsrLogsDownTimeFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching DSR logs.',
      description: `${error.error}`,
    });
  }
}

function* downTimeWatcher() {
  yield takeLatest(FETCH_DSR_LOGS_DOWNTIME, fetchDsrLogsDownTime);
}

function* downTimeSagas() {
  yield all([call(downTimeWatcher)]);
}

export default downTimeSagas;
